import { render } from "./SimpleDataList.vue?vue&type=template&id=7675bec7&scoped=true"
import script from "./SimpleDataList.vue?vue&type=script&lang=js"
export * from "./SimpleDataList.vue?vue&type=script&lang=js"

import "./SimpleDataList.vue?vue&type=style&index=0&id=7675bec7&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7675bec7"]])

export default __exports__